import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { CommonStore } from 'stores';

import Modal from 'components/Modal';

const FlashModal = ({ name }) => {
    const commonStore = useContext(CommonStore);
    const [show, setShow] = useState(false);
    const [modalProps, setModalProps] = useState({});

    useEffect(() => {
        const props = commonStore.getFlashModal(name);
        if (props) {
            setModalProps(props);
            setShow(true);
        }
    }, [commonStore, name]);

    const onModalCloseClick = () => {
        setShow(false);
    };

    if (!show) {
        return null;
    }

    return (
        <Modal
            {...modalProps}
            onCloseButtonClick={onModalCloseClick}
            actions={{
                align: 'center',
                primary: {
                    children: i18n._(t`Got it`),
                    theme: 'primary',
                    onClick: onModalCloseClick,
                },
            }}
        />
    );
};

FlashModal.defaultProps = {};

FlashModal.propTypes = {
    name: PropTypes.string.isRequired,
};

export default FlashModal;
